import React from 'react';
import {
  Home,
  Image as LucideImage,
  StickyNote,
  Plus,
  UserRound,
  Filter,
  LayoutGrid,
  List,
  Check,
  ArrowRight,
  ArrowUpRight,
  ChevronDown,
  ChevronUp,
  RefreshCcw,
  Cross,
  Pin,
  PenLine,
  X,
} from 'lucide-react';

const GLIMT_STAR_PATH =
  'M23.1184 0.37059C24.3989 -0.495321 26.234 0.257387 27.0167 1.5904C27.3361 2.13439 27.5769 2.75281 27.8182 3.39815C28.1843 4.42623 28.5201 5.46536 28.8208 6.51631C29.062 7.35927 29.8203 7.93269 30.3535 7.23662C30.7627 6.78672 31.1682 6.33352 31.5723 5.8784C32.4551 4.91032 33.3176 4.06801 34.4836 3.6423C34.9151 3.48479 35.409 3.44632 35.8674 3.47465C37.0301 3.54651 37.9537 4.51864 37.9492 5.68351C37.9488 5.78635 37.9447 5.89052 37.9373 5.99659C37.9067 6.43401 37.7913 6.86167 37.6176 7.26428C36.8583 9.02405 35.6242 10.491 34.4913 12.0078C34.3733 12.1738 34.2555 12.34 34.1379 12.5063C33.981 12.7282 34.1367 13.0347 34.4084 13.0395C35.2045 13.0552 36.0004 13.0742 36.7963 13.0951C37.1381 13.1035 37.48 13.1107 37.8218 13.1166C40.0106 13.1551 42.2734 13.2325 44.2363 14.1593C45.735 14.8669 46.9611 16.2789 46.9968 17.9358C47.0049 18.3088 46.9727 18.7014 46.9094 19.1317C46.6622 19.9807 46.1973 20.3926 45.553 20.9363C45.4744 21.015 45.3957 21.0936 45.3166 21.1727C45.1238 21.3656 44.9178 21.5457 44.6911 21.6973C41.9547 23.5276 38.5612 23.8292 35.3747 23.9706C35.1065 23.9825 34.9634 24.2926 35.1291 24.5037C35.6194 25.1333 36.1061 25.7657 36.5895 26.4012C36.8764 26.7779 37.1651 27.153 37.454 27.5281C39.2224 29.9107 41.5596 33.2803 41.2245 36.4975C40.9861 37.7504 39.9379 38.7751 38.6634 38.8226C38.2442 38.8383 37.8143 38.8006 37.3704 38.7396C34.7334 37.997 32.5307 36.23 30.6437 34.2015C30.3736 33.9155 30.3736 33.9155 30.098 33.6236C29.9458 33.4618 29.674 33.5663 29.6694 33.7884C29.6673 33.8908 29.6652 33.9938 29.6631 34.0979C29.5654 37.4335 29.3754 40.8081 27.6286 43.5223C26.9328 44.6035 25.9293 45.5804 24.6728 45.8537C23.6072 46.0855 22.4459 45.7699 21.6119 45.0673C21.0654 44.6069 20.6157 44.0176 20.2274 43.3563C19.1672 41.0198 19.0379 38.5534 18.9426 36.0048C18.9292 35.1297 18.9268 34.9748 18.7557 34.3928C18.7033 34.2146 18.4659 34.1805 18.3637 34.3356C14.3448 40.4078 14.1593 40.6882 11.5605 41.7015C11.2993 41.8034 10.9091 41.9065 10.6311 41.9429C9.95341 42.0317 9.39004 41.674 8.99484 41.1163C8.90327 40.9871 8.82484 40.8496 8.75234 40.692C8.56745 40.2902 8.49142 39.8464 8.47798 39.4043C8.3281 34.4721 11.8486 30.3491 14.5077 26.5944C15.0072 25.8875 15.4834 25.1716 15.9429 24.4379C16.0195 24.3156 15.8958 24.1671 15.7684 24.2346C15.7528 24.2429 15.7255 24.2537 15.7081 24.2557C13.1414 24.5552 10.5465 24.5627 7.96728 24.569C7.34371 24.5715 6.72033 24.5795 6.09681 24.5874C5.69289 24.5891 5.28898 24.5904 4.88506 24.5914C4.7024 24.5946 4.51975 24.5977 4.33156 24.601C3.67635 24.5981 3.0391 24.5433 2.41804 24.4104C1.16332 24.1419 0.0707204 23.2106 0.00432041 21.9292C-0.0461373 20.9555 0.315995 19.9398 1.0613 19.3111C2.925 17.739 6.12896 17.2477 8.22959 16.7191C9.83383 16.3582 11.4559 16.2822 13.0893 16.201C13.2985 16.19 13.5078 16.179 13.7233 16.1676C13.7297 16.1673 13.736 16.167 13.7424 16.1666C14.5889 16.1223 15.1737 15.4163 14.6458 14.7531C14.4507 14.5047 14.4507 14.5047 14.2516 14.2512C14.1111 14.0739 13.9705 13.8965 13.8257 13.7138C12.4372 11.9334 11.1527 10.1178 9.96315 8.18128C9.82924 7.96655 9.69532 7.75182 9.55735 7.53058C9.19255 6.80841 9.04931 6.0857 9.00839 5.31807C8.97446 4.68145 9.08118 3.98336 9.44945 3.46297C9.97326 2.72279 10.9147 2.47484 11.8215 2.47398C13.4275 2.47246 14.6766 2.92974 16.1224 4.09669C17.4485 5.22322 18.724 6.4132 19.9849 7.62054C20.1238 7.75356 20.355 7.68243 20.3947 7.49427C20.5362 6.83484 20.6828 6.17682 20.8295 5.51867C20.9004 5.18252 20.9004 5.18252 20.9727 4.83957C21.363 3.11327 21.8807 1.20754 23.1184 0.37059Z';

function GlimtStarGlyph({ size = 24, color = 'var(--color-accent, #56371F)', className = '', style, ...rest }) {
  const h = size;
  const w = size * (47 / 46);
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'block', ...style }}
      {...rest}
    >
      <path d={GLIMT_STAR_PATH} fill={color} />
    </svg>
  );
}

/**
 * Icon registry — maps the app's historical icon names to Lucide components.
 *
 * Keeping this registry (instead of importing Lucide icons directly at call
 * sites) means every existing `<Icon name="..." />` across the codebase keeps
 * working with no edits. The visual style, size, and color props are uniform
 * and Lucide-native.
 *
 * Each entry may specify an overridden default `strokeWidth` so small icons
 * don't look anemic and larger icons don't look bloated.
 */
const registry = {
  // navigation / core
  home:            { Cmp: Home,        strokeWidth: 2 },
  homeLight:       { Cmp: Home,        strokeWidth: 1.5 },
  pictures:        { Cmp: LucideImage, strokeWidth: 2 },
  picturesDark:    { Cmp: LucideImage, strokeWidth: 2.25 },
  notes:           { Cmp: StickyNote,  strokeWidth: 2 },
  notesLight:      { Cmp: StickyNote,  strokeWidth: 1.5 },
  plus:            { Cmp: Plus,        strokeWidth: 2 },
  plusLight:       { Cmp: Plus,        strokeWidth: 1.75 },
  plusLightNavBar: { Cmp: Plus,        strokeWidth: 1.5 },
  plusWht:         { Cmp: Plus,        strokeWidth: 2.25 },
  profile:         { Cmp: UserRound,   strokeWidth: 2 },
  filter:          { Cmp: Filter,      strokeWidth: 2 },
  grid:            { Cmp: LayoutGrid,  strokeWidth: 2 },
  list:            { Cmp: List,        strokeWidth: 2 },
  check:           { Cmp: Check,       strokeWidth: 2.25 },

  // directional / chevrons
  arrowRight:      { Cmp: ArrowRight,   strokeWidth: 2 },
  arrowRightUp:    { Cmp: ArrowUpRight, strokeWidth: 2 },

  // overlay toggles (were two-arrow expand/collapse glyphs)
  openOverlay:        { Cmp: ChevronDown, strokeWidth: 2 },
  closeOverlay:       { Cmp: ChevronUp,   strokeWidth: 2 },
  openOverlayBrown:   { Cmp: ChevronDown, strokeWidth: 2 },
  closeOverlayBrown:  { Cmp: ChevronUp,   strokeWidth: 2 },

  // misc
  changeImage: { Cmp: RefreshCcw, strokeWidth: 2 },
  change:      { Cmp: RefreshCcw, strokeWidth: 2 },
  lotus:       { Cmp: GlimtStarGlyph, strokeWidth: 1.75 },
  lotusGrey:   { Cmp: GlimtStarGlyph, strokeWidth: 1.75 },
  cross:       { Cmp: Cross,      strokeWidth: 1.75 },
  crossGrey:   { Cmp: Cross,      strokeWidth: 1.75 },
  pin:         { Cmp: Pin,        strokeWidth: 2 },
  pinGrey:     { Cmp: Pin,        strokeWidth: 2 },
  author:      { Cmp: PenLine,    strokeWidth: 2 },

  // close buttons
  x:       { Cmp: X, strokeWidth: 2 },
  xWhite:  { Cmp: X, strokeWidth: 2 },
};

/**
 * <Icon name="..." size={24} color="#000" />
 *
 * - `size`  is forwarded as both width and height.
 * - `color` becomes the stroke (Lucide uses currentColor by default).
 * - `strokeWidth` can be overridden per call; otherwise the registry default
 *    (or 2) is used.
 */
export default function Icon({
  name,
  size = 24,
  color,
  strokeWidth,
  className = '',
  ...rest
}) {
  const entry = registry[name];
  if (!entry) return null;
  const { Cmp, strokeWidth: defaultStroke = 2 } = entry;

  const strokeColor =
    color ??
    (name === 'xWhite'
      ? '#FFFFFF'
      : name === 'lotus'
        ? '#FFDB7B'
        : 'var(--color-accent, #56371F)');

  return (
    <Cmp
      size={size}
      color={strokeColor}
      strokeWidth={strokeWidth ?? defaultStroke}
      className={className}
      style={{ display: 'block' }}
      {...rest}
    />
  );
}
